import './JournalEntryAdd.scss';
import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import { useSelector } from 'react-redux';
import { MdDelete } from 'react-icons/md';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  addJournalEntry,
  getJournalEntryDetails,
  getParties,
  manageJournalEntry,
  updateJournalEntry,
} from '../../../network/journalEntry';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getAccounts,
  getPaymentEntries,
  getPaymentReferences,
} from '../../../network/PaymentEntry';
import dayjs from 'dayjs';
import { getCostCenters } from '../../../network/costCenter';
import JournalEntryAccountingList from './JournalEntryAccountingList';
import { getSearchApiAcount } from '../../../network/itemList';
import { submitMaterialRequest } from '../../../network/materialRequest';
import HeadingApp from '../../../hooks/HeadingApp';
import { IoIosJournal } from 'react-icons/io';

const JournalEntryAdd = ({ t, edit }) => {
  const { currentLang } = useSelector((state) => state.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const [dataStatus, setDataStatus] = useState(null);
  const [searchTxtAccount, setSearchTxtAccount] = useState('');
  const [submitButton, setSubmitButton] = useState(false);
  const [selectName, setSelectName] = useState('');
  const [dataSourceAccount, setDataSourceAccount] = useState([{}]);
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const { mutate: onAddJournalEntry } = useMutation({
    mutationKey: ['addJournalEntry'],
    mutationFn: (body) =>
      edit ? updateJournalEntry(body, id) : addJournalEntry(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getJournalEntries],
      });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/journal-entry');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      // message.error(error);
    },
  });
  // const { data: paymentReferences } =
  // useQuery({
  //   queryKey: [queryKeys.getPaymentReferences],
  //   queryFn: (id) => getPaymentReferences("Journal Entry"),
  // });
  // const { mutate: onGetParties, data: parties } = useMutation({
  //   mutationKey: [queryKeys.getParties],
  //   mutationFn: (id) => getParties(id),
  // });
  // const { data: costCenters } = useQuery({
  //   queryKey: [queryKeys.getCostCenters],
  //   queryFn: () => getCostCenters(),
  //   keepPreviousData: true,
  // });

  // const accountFilter = '{"is_group":0}';
  // const { data: accounts } = useQuery({
  //   queryKey: [queryKeys.getAccounts],
  //   queryFn: () => getAccounts(accountFilter),
  //   keepPreviousData: true,
  // });
  //  const { data: parties } = useQuery({
  //     queryKey: [queryKeys.getAccounts, searchTxtAccount],
  //     // queryFn: () => getAccounts(accountFilter),
  //     queryFn: () =>
  //       getSearchApiAcount({ type: 'Account', searchTxt: searchTxtAccount }),
  //     keepPreviousData: true,
  //     // select: (data) => data?.message?.accounts,
  //     select: (data) => data?.message,
  //   });
  // const { data: paymentEntries} = useQuery({
  //   queryKey: [queryKeys.getPaymentEntries],
  //   queryFn: () => getPaymentEntries(),
  //   keepPreviousData: true,
  // });
  // const journalAccounts = accounts?.message?.accounts;
  const handleManageJournal = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: ({ action: action, name: name }) =>
        submitMaterialRequest('Journal Entry', name),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          setLoadingAdd(false);
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        submitButton && navigate('/journal-entry');
        client.invalidateQueries({
          queryKey: [queryKeys.getJournalEntries, id],
        });
      },
      onError: (error) => {
        setLoadingAdd(false);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
      },
    }
  );
  // const { mutate: onGetPaymentReferences, data: paymentReferences } =
  // useMutation({
  //   mutationKey: [queryKeys.getPaymentReferences],
  //   mutationFn: (id) => getPaymentReferences(id),
  // });
  // console.log(paymentReferences, 'paymentReferences');
  const onFinish = (values) => {
    // console.log(values);
    setLoadingAdd(true);
    onAddJournalEntry({
      ...values,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      total_debit: Number(values?.total_debit),
      total_credit: Number(values?.total_credit),
      accounts: dataSourceAccount?.map((account) => {
        return {
          account: account?.account,
          cost_center: account?.cost_center,
          debit: Number(account?.debit),
          credit: Number(account?.credit),
          exchange_rate: 1.0,
          debit_in_account_currency: Number(account?.debit),
          credit_in_account_currency: Number(account?.credit),
          party_type: account?.party_type,
          party: account?.party,
          reference_type: account?.reference_type,
          reference_name: account?.reference_name,
          description: '',
        };
      }),
    });
  };
  const { data: journalEntry, isLoading: journalEntryLoading } = useQuery({
    queryKey: [queryKeys.getJournalEntryDetails, id],
    queryFn: () => getJournalEntryDetails(id),
    keepPreviousData: true,
    enabled: !!edit,
  });
  const { data: journalEntryName } = useQuery({
    queryKey: [queryKeys.getJournalEntryDetailsName, selectName],
    queryFn: () => getJournalEntryDetails(selectName),
    keepPreviousData: true,
    enabled: !!selectName && !edit,
  });
  useEffect(() => {
    if (journalEntry && edit) {
      setDataSourceAccount(
        journalEntry?.data?.accounts?.length
          ? journalEntry?.data?.accounts
          : [{}]
      );
      setDataStatus(journalEntry?.data?.docstatus);
      form.setFieldsValue({
        ...journalEntry?.data,
        posting_date: dayjs(journalEntry?.data?.posting_date),
        cheque_date: dayjs(journalEntry?.data?.cheque_date),
      });
    }
  }, [journalEntry, edit]);
  useEffect(() => {
    if (journalEntryName && !edit) {
      setDataSourceAccount(
        journalEntryName?.data?.accounts?.length
          ? journalEntryName?.data?.accounts
          : [{}]
      );
      setDataStatus(journalEntryName?.data?.docstatus);
      form.setFieldsValue({
        ...journalEntryName?.data,
        posting_date: dayjs(journalEntryName?.data?.posting_date),
        cheque_date: dayjs(journalEntryName?.data?.cheque_date),
      });
    }
  }, [journalEntryName, edit]);
  if (journalEntryLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '95vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const itemsMenu = [
    {
      key: '3',
      label: (
        <Button
          disabled={journalEntry?.data?.docstatus === 0 ? false : true}
          type="text"
          size="small"
        >
          {t.submitJournal}
        </Button>
      ),
      onClick: () => handleManageJournal.mutate({ action: 'submit', name: id }),
    },
    {
      key: '2',
      label: (
        <Button
          type="text"
          size="small"
          disabled={journalEntry?.data?.docstatus === 1 ? false : true}
          loading={loadingAdd}
        >
          {t.cancel}
        </Button>
      ),
      onClick: () => handleManageJournal.mutate({ action: 'cancel', name: id }),
    },

    {
      key: '4',
      label: (
        <Button
          type="text"
          size="small"
          disabled={journalEntry?.data?.docstatus === 1 ? false : true}
        >
          {t.GeneralLedger}
        </Button>
      ),
      onClick: () => {
        navigate(`/general-ledger-report-sales/${id}`);
      },
    },
  ];
  return (
    <div className="journal-entry-add">
      {/* <Heading
        title={t.JournalEntry}
        subTitle={t.addJournalEntry}
        path="/journal-entry"
        status={journalEntry?.data?.docstatus}
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.JournalEntry}
        subTitle={
          edit ? `${t.edit} ${t.JournalEntry}` : `${t.add} ${t.JournalEntry}`
        }
        icon={<IoIosJournal />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '20px',
          }}
        >
          {/* <Flex justify="space-between"> */}

          <h4>{t.ENTERJOURNALENTRYINFORMATION}</h4>
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              className="btn-light"
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              {/* <Divider orientation="left">{t.JournalEntryInformation}</Divider> */}
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    // name="firstName"
                    name="voucher_type"
                    label={t.EntryType}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select placeholder={t.EntryType}>
                      <Select.Option value="debit">Debit</Select.Option>
                      <Select.Option value="Journal Entry">
                        {currentLang === 'en'
                          ? 'Journal Entry'
                          : 'إفتتاحية المجلة'}
                      </Select.Option>
                      <Select.Option value="Inter Company Journal Entry">
                        {currentLang === 'en'
                          ? 'Inter Company Journal Entry'
                          : 'إفتتاحية المجلة بين الشركات'}
                      </Select.Option>
                      <Select.Option value="Bank Entry">
                        {currentLang === 'en' ? 'Bank Entry' : 'إفتتاحية البنك'}
                      </Select.Option>
                      <Select.Option value="Cash Entry">
                        {currentLang === 'en'
                          ? 'Cash Entry'
                          : 'إفتتاحية النقدية'}
                      </Select.Option>
                      <Select.Option value="Credit Card Entry">
                        {currentLang === 'en'
                          ? 'Credit Card Entry'
                          : 'إفتتاحية بطاقة الائتمان'}
                      </Select.Option>
                      <Select.Option value="Debit Note">
                        {currentLang === 'en' ? 'Debit Note' : 'مذكرة الدائنة'}
                      </Select.Option>
                      <Select.Option value="Credit Note">
                        {currentLang === 'en' ? 'Credit Note' : 'مذكرة المدينة'}
                      </Select.Option>
                      <Select.Option value="Contra Entry">
                        {currentLang === 'en'
                          ? 'Contra Entry'
                          : 'إفتتاحية المقابلة'}
                      </Select.Option>
                      <Select.Option value="Excise Entry">
                        {currentLang === 'en'
                          ? 'Excise Entry'
                          : 'إفتتاحية الضرائب'}
                      </Select.Option>
                      <Select.Option value="Write Off Entry">
                        {currentLang === 'en'
                          ? 'Write Off Entry'
                          : 'إفتتاحية إلغاء الدين'}
                      </Select.Option>
                      <Select.Option value="Opening Entry">
                        {currentLang === 'en'
                          ? 'Opening Entry'
                          : 'إفتتاحية الرصيد'}
                      </Select.Option>
                      <Select.Option value="Depreciation Entry">
                        {currentLang === 'en'
                          ? 'Depreciation Entry'
                          : 'إفتتاحية الاهلاك'}
                      </Select.Option>
                      <Select.Option value="Exchange Rate Revaluation">
                        {currentLang === 'en'
                          ? 'Exchange Rate Revaluation'
                          : 'إعادة تقييم سعر الصرف'}
                      </Select.Option>
                      <Select.Option value="Exchange Gain Or Loss">
                        {currentLang === 'en'
                          ? 'Exchange Gain Or Loss'
                          : 'ربح أو خسارة الصرف'}
                      </Select.Option>
                      <Select.Option value="Deferred Revenue">
                        {currentLang === 'en'
                          ? 'Deferred Revenue'
                          : 'إفتتاحية الإيرادات المؤجلة'}
                      </Select.Option>
                      <Select.Option value="Deferred Expense">
                        {currentLang === 'en'
                          ? 'Deferred Expense'
                          : 'إفتتاحية المصروفات المؤجلة'}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      placeholder={t.postingDate}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="cheque_no"
                label={t.ReferenceNumber}
                rules={[
                  {
                    required: true,
                  },
                  { min: 10 },
                ]}
              >
                <Input placeholder={t.ReferenceNumber} />
              </Form.Item>
            </Col> */}
                {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="cheque_date"
                label={t.ReferenceDate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  placeholder={t.ReferenceDate}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col> */}
                <Divider orientation="left">{t.AccountingEntries}</Divider>
                <Col span={24} className="items">
                  {/* <Form.List name="accounts" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Row
                        key={key}
                        style={{
                          width: '100%',
                        }}
                        gutter={[10, 0]}
                      >
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'account']}
                          label={t.Accounts}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          rules={[{ required: true }]}
                        >
                          <Select
                            placeholder={t.Accounts}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            // onChange={(value,option) => {
                            //     console.log(option,'option');
                            //   }
                            // }
                            options={journalAccounts?.map((item) => ({
                              value: item?.name,
                              label: item?.account_name,
                              data: { ...item, key },
                            }))}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'party_type']}
                          label={t.PartyType}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.PartyType}
                            style={{ width: '100%' }}
                            onChange={(value) => onGetParties(value)}
                            popupMatchSelectWidth={false}
                            options={[
                              { value: 'Customer', label: t.Customer },
                              {
                                value: 'Supplier',
                                label: t.Supplier,
                              },
                              {
                                value: 'Employee',
                                label: t.Employee,
                              },
                              {
                                value: 'Shareholder',
                                label: t.Shareholder,
                              },
                            ]}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'party']}
                          label={t.Party}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.Party}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            onChange={(value, option) => {
                              console.log(value, 'value', option, 'option');
                            }}
                            options={parties?.message?.parties?.map((item) => ({
                              value: item?.name,
                              label: item?.name,
                              data: { ...item, key },
                            }))}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'cost_center']}
                          label={t.costCenter}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.costCenter}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            options={costCenters?.data?.map((item) => ({
                              value: item?.name,
                              label: item?.cost_center_name,
                            }))}
                            hidden
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'debit']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Debit}
                        >
                          <Input
                            placeholder={t.Debit}
                            style={{ width: '100%' }}
                            type="number"
                            min={0}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'credit']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Credit}
                        >
                          <Input
                            placeholder={t.Credit}
                            style={{ width: '100%' }}
                            type="number"
                            min={0}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name={[name, 'reference_type']}
                          label={t.type}
                          style={{ width: '100%', marginBottom: '0px' }}
                          // rules={[{ required: true }]}
                          {...restField}
                        >
                          <Select
                            placeholder={t.type}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            onChange={(value) => {
                              // console.log(value, 'value');
                              onGetPaymentReferences(value);
                            }}
                            options={[
                              { value: 'Sales Invoice', label: t.salesInvoice },
                              {
                                value: 'Sales Order',
                                label: t.SalesOrder,
                              },
                              {
                                value: 'Duning',
                                label: t.Duning,
                              },
                              {
                                value: 'Journal Entry',
                                label: t.JournalEntry,
                              },
                            ]}
                          />
                        </Form.Item>
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                        <Flex alignItems="center" gap={5}>
                        <Form.Item
                          name={[name, 'reference_name']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Name}
                        >
                          <Select
                            placeholder={t.Name}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            // options={paymentEntries?.message?.payment_entries?.map(
                            //   (item) => ({
                            //     value: item?.name,
                            //     label: item?.name,
                            //     data: item,
                            //   })
                            // )}
                            options={paymentReferences?.message?.references?.map(
                              (item) => ({
                                value: item?.name,
                                label: item?.name,
                                data: item,
                              })
                            )}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                        </Flex>
                        </Col>
                      </Row>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <JournalEntryAccountingList
                    t={t}
                    setDataSourceAccount={setDataSourceAccount}
                    dataSourceAccount={dataSourceAccount}
                  />
                </Col>
                <Divider orientation="left">{t.user_remark}</Divider>
                <Form.Item
                  name="user_remark"
                  label={t.user_remark}
                  //  rules={[
                  //    {
                  //      required: true,
                  //    },
                  //  ]}
                  style={{ width: '100%' }}
                >
                  <Input.TextArea
                    rows={4}
                    placeholder={t.user_remark}
                    style={{ width: '100%' }}
                    autoSize={{ minRows: 6, maxRows: 7 }}
                  />
                </Form.Item>
                {edit ? (
                  <>
                    <Divider orientation="left">{t.total}</Divider>
                    <Col xs={24} sm={12} md={8} lg={8}>
                      <Form.Item
                        name="total_debit"
                        label={t.totalDebit}
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder={t.totalDebit} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8}>
                      <Form.Item
                        name="total_credit"
                        label={t.totalCredit}
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder={t.totalCredit} disabled />
                      </Form.Item>
                    </Col>
                  </>
                ) : selectName ? (
                  <>
                    <Divider orientation="left">{t.total}</Divider>
                    <Col xs={24} sm={12} md={8} lg={8}>
                      <Form.Item
                        name="total_debit"
                        label={t.totalDebit}
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder={t.totalDebit} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8}>
                      <Form.Item
                        name="total_credit"
                        label={t.totalCredit}
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder={t.totalCredit} disabled />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate('/journal-entry')}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  // block
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleManageJournal.mutate({
                        action: 'submit',
                        name: selectName,
                      });
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton
                    ? t.submit + ' ' + t.journal
                    : edit
                    ? t.edit + ' ' + t.journal
                    : t.Save + ' ' + t.journal}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default JournalEntryAdd;
